(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["elvyora-box-product"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initElvyoraBox(root) {
    if (!root || root.dataset.initialized === 'true') return;
    root.dataset.initialized = 'true';
    var maxItems = 5;
    var categories = Array.prototype.slice.call(root.querySelectorAll('[data-box-category]'));
    var totalNodes = root.querySelectorAll('[data-box-total]');
    var stickyTotal = root.querySelector('[data-sticky-total]');
    var progress = root.querySelector('[data-box-progress]');
    var fill = root.querySelector('[data-box-progress-fill]');
    var status = root.querySelector('[data-box-status]');
    var submit = root.querySelector('[data-box-submit]');
    var sticky = root.querySelector('[data-box-sticky]');
    var stickySubmit = root.querySelector('[data-sticky-submit]');
    var form = root.querySelector('form');
    var ringSize = root.querySelector('[data-ring-size]');
    var ringLabel = root.querySelector('[data-ring-label]');
    function countTotal() { return categories.reduce(function (sum, row) { return sum + parseInt(row.querySelector('[data-box-count]').textContent || '0', 10); }, 0); }
    function ringsCount() { var ringRow = categories.find(function (row) { return row.getAttribute('data-category') === 'Bagues'; }); return ringRow ? parseInt(ringRow.querySelector('[data-box-count]').textContent || '0', 10) : 0; }
    function syncRingSize() {
      if (!ringSize) return;
      var hasRings = ringsCount() > 0;
      ringSize.required = hasRings;
      if (!hasRings) { ringSize.value = 'Non concerné'; if (ringLabel) ringLabel.textContent = 'Aucune bague sélectionnée — cette étape est facultative.'; }
      else { if (ringSize.value === 'Non concerné') ringSize.value = 'Ajustable'; if (ringLabel) ringLabel.textContent = 'Choisissez votre taille. En cas de doute, sélectionnez « Ajustable ».'; }
    }
    function update() {
      var total = countTotal();
      var complete = total === maxItems;
      totalNodes.forEach(function (node) { node.textContent = total; });
      if (stickyTotal) stickyTotal.textContent = total;
      if (progress) progress.setAttribute('aria-valuenow', total);
      if (fill) fill.style.width = Math.min(100, (total / maxItems) * 100) + '%';
      if (status) status.textContent = complete ? 'Votre sélection est complète ✓' : 'Il vous reste ' + (maxItems - total) + ' pièce' + ((maxItems - total) > 1 ? 's' : '') + ' à choisir.';
      if (submit) submit.disabled = !complete;
      if (stickySubmit) stickySubmit.disabled = !complete;
      var submitCopy = root.querySelector('[data-box-submit-copy]');
      if (submitCopy) submitCopy.textContent = complete ? 'Ajouter l’ELVYORA BOX au panier' : 'Complétez votre sélection — ' + total + '/5';
      categories.forEach(function (row) {
        var value = parseInt(row.querySelector('[data-box-count]').textContent || '0', 10);
        var minus = row.querySelector('[data-box-minus]');
        var plus = row.querySelector('[data-box-plus]');
        if (minus) minus.disabled = value <= 0;
        if (plus) plus.disabled = total >= maxItems;
      });
      syncRingSize();
    }
    categories.forEach(function (row) {
      var count = row.querySelector('[data-box-count]');
      var input = row.querySelector('[data-box-input]');
      var minus = row.querySelector('[data-box-minus]');
      var plus = row.querySelector('[data-box-plus]');
      function setValue(next) {
        var currentTotal = countTotal();
        var current = parseInt(count.textContent || '0', 10);
        next = Math.max(0, next);
        if (next > current && currentTotal >= maxItems) return;
        count.textContent = next;
        input.value = String(next);
        update();
      }
      if (minus) minus.addEventListener('click', function () { setValue(parseInt(count.textContent || '0', 10) - 1); });
      if (plus) plus.addEventListener('click', function () { setValue(parseInt(count.textContent || '0', 10) + 1); });
    });
    if (stickySubmit && submit) stickySubmit.addEventListener('click', function () { if (!submit.disabled) submit.click(); });
    if (form) form.addEventListener('submit', function (event) {
      if (countTotal() !== maxItems) { event.preventDefault(); if (status) status.textContent = 'Sélectionnez exactement 5 pièces avant de continuer.'; return; }
      if (ringsCount() > 0 && ringSize && !ringSize.value) { event.preventDefault(); ringSize.focus(); }
    });
    if (sticky) sticky.hidden = false;
    update();
  }
  function initAll() { document.querySelectorAll('[data-elvyora-box]').forEach(initElvyoraBox); }
  document.addEventListener('DOMContentLoaded', initAll);
  document.addEventListener('shopify:section:load', initAll);
  initAll();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["elvyora-home"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-evx-slider]').forEach((slider) => {
    const slides = Array.from(slider.querySelectorAll('[data-evx-slide]'));
    const dots = slider.querySelector('[data-evx-dots]');
    const pause = slider.querySelector('[data-evx-pause]');
    const delay = Number(slider.dataset.delay) || 6000;
    let current = 0;
    let timer;
    let paused = false;
    let startX = 0;
    let startY = 0;
    slider.addEventListener('touchstart', (event) => { startX = event.changedTouches[0].screenX; startY = event.changedTouches[0].screenY; }, {passive:true});
    slider.addEventListener('touchend', (event) => { const distance = event.changedTouches[0].screenX - startX; if (Math.abs(distance) > 60 && Math.abs(distance) > Math.abs(event.changedTouches[0].screenY - startY) * 1.2) { show(current + (distance < 0 ? 1 : -1)); restart(); } }, {passive:true});
    const show = (index) => {
      current = (index + slides.length) % slides.length;
      slides.forEach((slide, slideIndex) => {
        const active = slideIndex === current;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', String(!active));
        slide.querySelector('a').tabIndex = active ? 0 : -1;
      });
      Array.from(dots.children).forEach((dot, dotIndex) => dot.classList.toggle('is-active', dotIndex === current));
    };
    const restart = () => {
      window.clearInterval(timer);
      if (!paused && slides.length > 1 && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) timer = window.setInterval(() => show(current + 1), delay);
    };
    slides.forEach((slide, index) => {
      const dot = document.createElement('button');
      dot.type = 'button';
      dot.setAttribute('aria-label', `${index + 1} / ${slides.length}`);
      if (index === 0) dot.classList.add('is-active');
      dot.addEventListener('click', () => { show(index); restart(); });
      dots.appendChild(dot);
    });
    slider.querySelector('[data-evx-prev]').addEventListener('click', () => { show(current - 1); restart(); });
    slider.querySelector('[data-evx-next]').addEventListener('click', () => { show(current + 1); restart(); });
    pause.addEventListener('click', () => {
      paused = !paused;
      pause.querySelector('[data-pause-icon]').textContent = paused ? '▶' : 'Ⅱ';
      restart();
    });
    slider.addEventListener('mouseenter', () => window.clearInterval(timer));
    slider.addEventListener('mouseleave', restart);
    slider.addEventListener('focusin', () => window.clearInterval(timer));
    slider.addEventListener('focusout', restart);
    restart();
  });
  document.querySelectorAll('[data-evx-products]').forEach((section) => {
    const tabs = Array.from(section.querySelectorAll('[data-product-tab]'));
    const panels = Array.from(section.querySelectorAll('[data-product-panel]'));
    tabs.forEach((tab, index) => tab.addEventListener('click', () => {
      tabs.forEach((item, itemIndex) => item.setAttribute('aria-selected', String(itemIndex === index)));
      panels.forEach((panel, panelIndex) => { panel.hidden = panelIndex !== index; panel.classList.toggle('is-active', panelIndex === index); });
    }));
  });
  const editorialVideos = Array.from(document.querySelectorAll('.evx-story video'));
  const playEditorialVideo = (video) => {
    video.muted = true;
    video.playsInline = true;
    const playback = video.play();
    if (playback && typeof playback.catch === 'function') playback.catch(() => {});
  };
  if ('IntersectionObserver' in window) {
    const videoObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        const video = entry.target;
        if (entry.isIntersecting) playEditorialVideo(video);
        else video.pause();
      });
    }, { rootMargin: '120px 0px', threshold: 0.08 });
    editorialVideos.forEach((video) => videoObserver.observe(video));
  } else {
    editorialVideos.forEach(playEditorialVideo);
  }
  document.addEventListener('visibilitychange', () => {
    if (!document.hidden) editorialVideos.forEach((video) => {
      const rect = video.getBoundingClientRect();
      if (rect.bottom > 0 && rect.top < window.innerHeight) playEditorialVideo(video);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
